<ag-grid-angular [gridOptions]="gridOptions" [ngClass]="[theme]" style="width: 100%;height: 100%"></ag-grid-angular>

<ng-template #limitModalTpl let-dialogRefTemplate="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Maximum limit has been reached</h3>
      <button type="button" class="btn-close" (click)="dialogRefTemplate.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div class="alert alert-warning" style="margin: 0">
      Maximum limit has been reached. Please purchase the full report to access more features.
    </div>
  </div>
</ng-template>
